/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides, BigNumberish } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Staking, StakingInterface } from "../Staking";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_celerTokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_proposalDeposit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_votingPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_unbondingPeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxBondedValidators",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minValidatorTokens",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_minSelfDelegation",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_advanceNoticePeriod",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_validatorBondInterval",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_maxSlashFactor",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "valAddr",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "delAddr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "valTokens",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "delShares",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "int256",
        name: "tokenDiff",
        type: "int256",
      },
    ],
    name: "DelegationUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "valAddr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "nonce",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "slashAmt",
        type: "uint256",
      },
    ],
    name: "Slash",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SlashAmtCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "valAddr",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "delAddr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Undelegated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "valAddr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "key",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
    ],
    name: "ValidatorNotice",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "valAddr",
        type: "address",
      },
      {
        indexed: true,
        internalType: "enum DataTypes.ValidatorStatus",
        name: "status",
        type: "uint8",
      },
    ],
    name: "ValidatorStatusUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "WhitelistedAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "WhitelistedRemoved",
    type: "event",
  },
  {
    inputs: [],
    name: "CELER_TOKEN",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addPauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addWhitelisted",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bondValidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bondedTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "bondedValAddrs",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "collectForfeiture",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
    ],
    name: "completeUndelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
    ],
    name: "confirmUnbondedValidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokens",
        type: "uint256",
      },
    ],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "drainToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "forfeiture",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBondedValidatorNum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBondedValidatorsTokens",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "valAddr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokens",
            type: "uint256",
          },
        ],
        internalType: "struct DataTypes.ValidatorTokens[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_delAddr",
        type: "address",
      },
    ],
    name: "getDelegatorInfo",
    outputs: [
      {
        components: [
          {
            internalType: "address",
            name: "valAddr",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokens",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "shares",
            type: "uint256",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "shares",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "creationBlock",
                type: "uint256",
              },
            ],
            internalType: "struct DataTypes.Undelegation[]",
            name: "undelegations",
            type: "tuple[]",
          },
          {
            internalType: "uint256",
            name: "undelegationTokens",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "withdrawableUndelegationTokens",
            type: "uint256",
          },
        ],
        internalType: "struct DataTypes.DelegatorInfo",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum DataTypes.ParamName",
        name: "_name",
        type: "uint8",
      },
    ],
    name: "getParamValue",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getQuorumTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getValidatorNum",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
    ],
    name: "getValidatorStatus",
    outputs: [
      {
        internalType: "enum DataTypes.ValidatorStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
    ],
    name: "getValidatorTokens",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "govContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_checkSelfDelegation",
        type: "bool",
      },
    ],
    name: "hasMinRequiredTokens",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_signer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_minSelfDelegation",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "_commissionRate",
        type: "uint64",
      },
    ],
    name: "initializeValidator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_addr",
        type: "address",
      },
    ],
    name: "isBondedValidator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isPauser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isWhitelisted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nextBondBlock",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum DataTypes.ParamName",
        name: "",
        type: "uint8",
      },
    ],
    name: "params",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pausers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removeWhitelisted",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renouncePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardContract",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_addr",
        type: "address",
      },
    ],
    name: "setGovContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_maxSlashFactor",
        type: "uint256",
      },
    ],
    name: "setMaxSlashFactor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "enum DataTypes.ParamName",
        name: "_name",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
    ],
    name: "setParamValue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_addr",
        type: "address",
      },
    ],
    name: "setRewardContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_whitelistEnabled",
        type: "bool",
      },
    ],
    name: "setWhitelistEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "signerVals",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_slashRequest",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
    ],
    name: "slash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "slashNonces",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_shares",
        type: "uint256",
      },
    ],
    name: "undelegateShares",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokens",
        type: "uint256",
      },
    ],
    name: "undelegateTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "_newRate",
        type: "uint64",
      },
    ],
    name: "updateCommissionRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_minSelfDelegation",
        type: "uint256",
      },
    ],
    name: "updateMinSelfDelegation",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_signer",
        type: "address",
      },
    ],
    name: "updateValidatorSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "valAddrs",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_valAddr",
        type: "address",
      },
      {
        internalType: "string",
        name: "_key",
        type: "string",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "validatorNotice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "validators",
    outputs: [
      {
        internalType: "enum DataTypes.ValidatorStatus",
        name: "status",
        type: "uint8",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokens",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "shares",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "undelegationTokens",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "undelegationShares",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "minSelfDelegation",
        type: "uint256",
      },
      {
        internalType: "uint64",
        name: "bondBlock",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "unbondBlock",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "commissionRate",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_msg",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
    ],
    name: "verifySignatures",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_msg",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    name: "verifySigs",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelist",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "whitelistEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type StakingConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: StakingConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class Staking__factory extends ContractFactory {
  constructor(...args: StakingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Staking";
  }

  deploy(
    _celerTokenAddress: string,
    _proposalDeposit: BigNumberish,
    _votingPeriod: BigNumberish,
    _unbondingPeriod: BigNumberish,
    _maxBondedValidators: BigNumberish,
    _minValidatorTokens: BigNumberish,
    _minSelfDelegation: BigNumberish,
    _advanceNoticePeriod: BigNumberish,
    _validatorBondInterval: BigNumberish,
    _maxSlashFactor: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<Staking> {
    return super.deploy(
      _celerTokenAddress,
      _proposalDeposit,
      _votingPeriod,
      _unbondingPeriod,
      _maxBondedValidators,
      _minValidatorTokens,
      _minSelfDelegation,
      _advanceNoticePeriod,
      _validatorBondInterval,
      _maxSlashFactor,
      overrides || {},
    ) as Promise<Staking>;
  }
  getDeployTransaction(
    _celerTokenAddress: string,
    _proposalDeposit: BigNumberish,
    _votingPeriod: BigNumberish,
    _unbondingPeriod: BigNumberish,
    _maxBondedValidators: BigNumberish,
    _minValidatorTokens: BigNumberish,
    _minSelfDelegation: BigNumberish,
    _advanceNoticePeriod: BigNumberish,
    _validatorBondInterval: BigNumberish,
    _maxSlashFactor: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(
      _celerTokenAddress,
      _proposalDeposit,
      _votingPeriod,
      _unbondingPeriod,
      _maxBondedValidators,
      _minValidatorTokens,
      _minSelfDelegation,
      _advanceNoticePeriod,
      _validatorBondInterval,
      _maxSlashFactor,
      overrides || {},
    );
  }
  attach(address: string): Staking {
    return super.attach(address) as Staking;
  }
  connect(signer: Signer): Staking__factory {
    return super.connect(signer) as Staking__factory;
  }
  static readonly contractName: "Staking";
  public readonly contractName: "Staking";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StakingInterface {
    return new utils.Interface(_abi) as StakingInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Staking {
    return new Contract(address, _abi, signerOrProvider) as Staking;
  }
}
